'use strict';

export class InvitationAttachmentCtrl
{
    $filter;

    notify;

    cfg = {
        fileFilter: {},
        uploadUrl: '',
        removeUrl: '',
        saveUrl: '',
    };

    attfile = {
        file: {}
    };

    uploadUrl = '';

    attachments = [];

    constructor($scope, $http, $mdDialog, $filter, notify, jsDataService){
        this.$scope = $scope;
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.jsDataService = jsDataService;
        this.$filter = $filter;
        this.notify = notify;
        this.cfg.uploadUrl = jsDataService.get('cfgUploadUrl');
        this.cfg.saveUrl = jsDataService.get('cfgSaveUrl');
        this.cfg.removeUrl = jsDataService.get('cfgRemoveUrl');
        this.cfg.fileFilter = jsDataService.get('cfgFileFilter', {});
        this.cfg.maxFileSize = jsDataService.get('maxFileSize', 0);

        let invitation = this.jsDataService.get('item', {});
        if(typeof(invitation.attachments) === 'object'){
            this.attachments = invitation.attachments;
        }
    }

    attachmentName(attachment){
        return 'name_'+attachment.number;
    }

    fileAdded($file) {
        const ext = $file.getExtension();
        if(typeof(this.cfg.fileFilter[ext]) === 'undefined' || !this.cfg.fileFilter[ext]){
			this.notify(this.$filter('tr')('file_wrong_format'), true);
            return false;
        }
        if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
            this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
            return false;
        }

        if(!this.activeUpload()){
            return false;
        }

        this.addFlowFile($file);
        return true;
    }

    activeUpload(){
        return true;
    }

    addFlowFile($file){
        this.attfile.file = {
            file_id: '0',
            nrId: $file.uniqueIdentifier,
            file_name: $file.name,
            isFlow: true,
            flowFile: $file,
            done: false
        };
    }

    fileSubmited(){
        this.attfile.flow.upload();
    }

    fileUploaded($file, $message, $flow){
        if($file.response.success){
            this.attfile.file.file_id = $file.response.fileId;
            this.attfile.file.done = true;
            this.saveAttachment(this.attfile);
        }
    }

    saveAttachment(attachment){
        let data = {
            file_id: attachment.file.file_id,
            title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, '')
        };
        if(this.cfg.saveUrl && this.cfg.saveUrl !== ''){
            this.$scope.basicHttpConfigProcess({
                url: this.cfg.saveUrl,
                method: 'POST',
                data: data
            }).then((response) => {
                if(response.data.success && typeof(response.data.items) !== 'undefined'){
                    this.attachments = response.data.items;
                    this.attfile.file = {};
                }
            }, () => {});
        }
        else{
            console.log('no url ', this.cfg.saveUrl);
        }
    }

    removeAttachment(ev, attachment){
        if(this.cfg.removeUrl !== ''){
            const confirmTexts = this.jsDataService.get('attachmentRemoveConfirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.cfg.removeUrl,
                    method: 'GET',
                    responseType: 'json',
                    params: {
                        id: attachment.id
                    }
                }).then((response) => {
                    if(response.data.success && typeof(response.data.items) !== 'undefined'){
                        this.attachments = response.data.items;
                    }
                });
            }, () => {});
        }
    }

    autosavePostFields(){
        return {
            attachments: this.attachments
        };
    }
}